import React, { useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import {
  Download as DownloadIcon,
  TableChart as TableChartIcon,
} from '@mui/icons-material';
import { reportsService } from '../../services/reports.service';
import toast from 'react-hot-toast';
import { DateRange } from '../../types/reports.types';

interface ExportButtonProps {
  dateRange?: DateRange;
}

export const ExportButton: React.FC<ExportButtonProps> = ({ dateRange }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isExporting, setIsExporting] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportCSV = async () => {
    handleClose();
    setIsExporting(true);
    try {
      const blob = await reportsService.exportToCSV(dateRange);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `leads-report-${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      toast.success('Report exported successfully');
    } catch (error) {
      toast.error('Failed to export report');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <>
      <Button
        variant='outlined'
        startIcon={<DownloadIcon />}
        onClick={handleClick}
        disabled={isExporting}
      >
        {isExporting ? 'Exporting...' : 'Export'}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleExportCSV}>
          <ListItemIcon>
            <TableChartIcon fontSize='small' />
          </ListItemIcon>
          <ListItemText>Export as CSV</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};